module.exports = __webpack_public_path__ + "static/media/logo_sell.7bc44a59.png";